
export const depositMethods = [
    "No Deposit",
    "EFT / Bank Transfer",
    "Cash",
    "Credit Card",
    "Cheque",
];

export const balanceMethods = [
    "EFT / Bank Transfer",
    "Cash",
    "Credit Card",
    "Cheque",
    "Costco"
]